import NotificacionApi from "../api/NotificacionApi";
import alerts from "../shared/alerts";

export default {
    getNotificaciones:async()=>{
        const response = await NotificacionApi.getNotificaciones();
        if(!response.success){
            alerts.error("Aviso", response.message);
        }
        return response;
    },
    getNotificacionesBySystem:async(id_sistema)=>{
        const response = await NotificacionApi.getNotificacionesBySystem(id_sistema);
        if(!response.success){
            alerts.error("Aviso", response.message);
        }
        return response;
    },
    getNotificacionsByUser:async(id_usuario)=>{
        const response = await NotificacionApi.getNotificacionsByUser(id_usuario);
        if(!response.success){
            alerts.error("Aviso", response.message);
        }
        return response;
    },
    createNotificacion:async(data)=>{
        const response = await NotificacionApi.createNotificacion(data);
        if(!response.success){
            alerts.error("Aviso", response.message);
        }
        return response;
    },
    updateNotificacion:async(data)=>{
        const response = await NotificacionApi.updateNotificacion(data);
        if(!response.success){
            alerts.error("Aviso", response.message);
        }
        return response;
    },
    deleteNotificacion:async(id)=>{
        const response = await NotificacionApi.deleteNotificacion(id);
        if(!response.success){
            alerts.error("Aviso", response.message);
        }
        return response;
    }

}